import { observer } from 'mobx-react-lite';
import React, { useRef } from 'react';
import { Button, Divider, Icon, Segment } from 'semantic-ui-react';
import { FileUploadInterface } from '../../../app/models/Profile';
import { ReceivingDelivery } from '../../../app/models/ReceivingDelivery';
import { Table } from 'semantic-ui-react';
import { Image } from 'semantic-ui-react';
import ReactToPrint from 'react-to-print';
import { useStore } from '../../../app/stores/store';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';

interface Props {
  printViewvalues: ReceivingDelivery;
  printViewImg: FileUploadInterface[];
  PrintViewDate: string;
}

function PackageReceiptPrintView({
  printViewvalues,
  printViewImg,
  PrintViewDate,
}: Props) {
  const componentRef = useRef<HTMLDivElement>(null);
  const {
    modalStore,
    commonStore,
    userStore: { user },
  } = useStore();
  return (
    <>
      <div className="print-view-modal" ref={componentRef}>
        <Segment>
          <img
            src="/assets/logo.png"
            alt="logo"
            className="ui centered image"
          />
          <Table definition>
            <Table.Body>
              <Table.Row>
                <Table.Cell width={6}>
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingRegisterPrintReceiptModal
                        ?.IRRPMTH01 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  :
                </Table.Cell>
                <Table.Cell>{printViewvalues.receivingTitle}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingRegisterPrintReceiptModal
                        ?.IRRPMTH02 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  :
                </Table.Cell>
                <Table.Cell>{printViewvalues.type}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingRegisterPrintReceiptModal
                        ?.IRRPMTH03 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  :
                </Table.Cell>
                <Table.Cell>{printViewvalues.sender_Details}</Table.Cell>
              </Table.Row>
              <Table.Row
                style={user?.customerName === 'CG' ? { display: 'none' } : {}}
              >
                <Table.Cell>
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingRegisterPrintReceiptModal
                        ?.IRRPMTH04 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  :
                </Table.Cell>
                <Table.Cell>{printViewvalues.mode_of_transport}</Table.Cell>
              </Table.Row>
              <Table.Row
                style={user?.customerName === 'CG' ? { display: 'none' } : {}}
              >
                <Table.Cell>
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingRegisterPrintReceiptModal
                        ?.IRRPMTH05 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  :
                </Table.Cell>
                <Table.Cell>
                  {printViewvalues.mode_of_transport_number}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingRegisterPrintReceiptModal
                        ?.IRRPMTH06 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  :
                </Table.Cell>
                <Table.Cell>{PrintViewDate}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingRegisterPrintReceiptModal
                        ?.IRRPMTH07 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  :
                </Table.Cell>
                <Table.Cell>{printViewvalues.receiver_Description}</Table.Cell>
              </Table.Row>
              <Table.Row
                style={user?.customerName === 'CG' ? { display: 'none' } : {}}
              >
                <Table.Cell>
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingRegisterPrintReceiptModal
                        ?.IRRPMTH08 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  :
                </Table.Cell>
                <Table.Cell>{printViewvalues.barcode_Package}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <Segment>
            <Image.Group size="small">
              {printViewImg.map((imgUrl) => {
                return <Image src={imgUrl.url} />;
              })}
            </Image.Group>
          </Segment>
        </Segment>
      </div>
      <Divider horizontal></Divider>
      <Button
        color="black"
        onClick={() => modalStore.closeSmallModal()}
        size="small"
        style={{ padding: '14px', width: '4.5vw', marginTop: '-25px' }} //Cancel
      >
        {
          (
            userLanguage[0].Level3InventoryRecievingRegisterPrintReceiptModal
              ?.IRRPMB01 as any
          )?.[`${commonStore.language.key}`]
        }
      </Button>
      <ReactToPrint
        trigger={() => (
          <Button
            positive
            //Print
          >
            <Icon name="print" size="large" />
            {
              (
                userLanguage[0]
                  .Level3InventoryRecievingRegisterPrintReceiptModal
                  ?.IRRPMB02 as any
              )?.[`${commonStore.language.key}`]
            }
          </Button>
        )}
        content={() => componentRef.current}
      />
    </>
  );
}

export default observer(PackageReceiptPrintView);
